import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-58">
          "Recursos visuales y prácticos para trabajar emociones, convivencia,
          diversidad, autocuidado y ciudadanía digital durante todo el año"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-59">
          <span className="px-2 text-[#EF5B4C] bg-[#FFFFFF] text-[24px]" data-id="element-60">
            MEGAPACK ESI PRIMARIA
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-61">
          Material diseñado especialmente para docentes que necesitan trabajar
          Educación Sexual Integral de forma simple, organizada y con
          actividades listas para usar.
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-62">
          <img src="https://cdn.magicpatterns.com/uploads/qw9XxQHCdALsJhS46viPhX/mockup_principal.png" alt="Megapack ESI Primaria" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-63" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-64">
          <p className="text-[14px]" data-id="element-65">
            Actividades listas para imprimir y entrar al aula.
          </p>
        </div>

        <div className="bg-[#EAF8F6] rounded-2xl p-5 max-w-md mx-auto border border-[#C9EDE8]" data-id="element-66">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-67">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-68">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-69">
              <span className="text-green-600 mr-2 text-lg" data-id="element-70">✔️</span>{' '}
              Actividades listas para usar
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-71">
              <span className="text-green-600 mr-2 text-lg" data-id="element-72">✔️</span> Menos
              tiempo de planificación
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-73">
              <span className="text-green-600 mr-2 text-lg" data-id="element-74">✔️</span> Recursos
              visuales y claros
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-75">
              <span className="text-green-600 mr-2 text-lg" data-id="element-76">✔️</span> Mayor
              participación de los estudiantes
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-77">
              <span className="text-green-600 mr-2 text-lg" data-id="element-78">✔️</span> Primer
              Ciclo y Segundo Ciclo completos
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-79">
              <span className="text-green-600 mr-2 text-lg" data-id="element-80">✔️</span> Material
              para todo el año escolar
            </p>
          </div>
        </div>
      </div>
    </section>;
}